import { createContext } from 'react'

import noop from 'shared/utils/noop'

export const emtpySubmitAction = () => noop

const AddressFormContext = createContext({
  postBillingSubmitAction: emtpySubmitAction,
  setPostBillingSubmitAction: noop,
  postShippingSubmitAction: emtpySubmitAction,
  setPostShippingSubmitAction: noop,
})
AddressFormContext.displayName = 'AddressFormContext'

export default AddressFormContext
